import React from 'react';
import { Users, TreePine, Heart, HandHeart } from 'lucide-react';
export function WhyChooseUs() {
  const cards = [{
    icon: <Users className="w-7 h-7 text-white" data-id="element-280" />,
    title: 'Equipo multidisciplinario',
    text: 'Psicólogos, terapeutas y otros profesionales con experiencia en acompañamiento terapéutico.'
  }, {
    icon: <TreePine className="w-7 h-7 text-white" data-id="element-281" />,
    title: 'Ambientes seguros y naturales',
    text: 'Instalaciones rodeadas de áreas verdes y espacios pensados para una mejor recuperación emocional.'
  }, {
    icon: <Heart className="w-7 h-7 text-white" data-id="element-282" />,
    title: 'Enfoque integral',
    text: 'Metodologías que consideran las necesidades individuales y familiares de cada persona.'
  }, {
    icon: <HandHeart className="w-7 h-7 text-white" data-id="element-283" />,
    title: 'Asesoría y acompañamiento',
    text: 'Orientación durante las distintas etapas del proceso, desde el primer contacto hasta la readaptación.'
  }];
  return <section className="py-16 md:py-24 bg-azul" data-id="element-284">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        <div className="text-center mb-16" data-id="element-286">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-287">
            ¿Por qué elegir Evolución Chile?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-288">
          {cards.map((card, index) => <div key={index} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 flex flex-col sm:flex-row items-start gap-6" data-id="element-289">
              <div className="flex-shrink-0 w-14 h-14 bg-celeste rounded-xl flex items-center justify-center shadow-sm" data-id="element-290">
                {card.icon}
              </div>
              <div data-id="element-291">
                <h3 className="text-xl font-semibold text-white mb-2" data-id="element-292">
                  {card.title}
                </h3>
                <p className="text-blue-100 leading-relaxed" data-id="element-293">{card.text}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}